// extracted by mini-css-extract-plugin
module.exports = {"melodyCardCategory":"Mf","categoryName":"Nf","categoryImage":"Of","categoryContent":"Pf","bottomAligned":"Qf"};